// Quote text and attributions are tied to the cited original work or speech.
// Keep source links visible wherever a quote is displayed.
export const QUOTES = {
  plutarchKindling: {
    text: 'For the mind does not require filling like a bottle, but rather, like wood, it only requires kindling to create in it an impulse to think independently and an ardent desire for the truth.',
    author: 'Plutarch',
    source: 'On Listening to Lectures (Moralia 48C), trans. F. C. Babbitt, Loeb Classical Library, 1927',
    sourceUrl: 'https://penelope.uchicago.edu/Thayer/E/Roman/Texts/Plutarch/Moralia/De_auditu*.html',
  },
  aristotleOrnament: {
    text: 'Education is an ornament in prosperity and a refuge in adversity.',
    author: 'Aristotle (as reported by Diogenes Laertius)',
    source: 'Lives of Eminent Philosophers, Book V, §19, trans. R. D. Hicks, Loeb Classical Library, 1925',
    sourceUrl: 'https://www.perseus.tufts.edu/hopper/text?doc=Perseus%3Atext%3A1999.01.0258%3Abook%3D5',
  },
  malalaChild: {
    text: 'One child, one teacher, one book, and one pen can change the world.',
    author: 'Malala Yousafzai',
    source: 'Address to the United Nations Youth Assembly, 12 July 2013',
    sourceUrl: 'https://webtv.un.org/en/asset/k0d/k0ds3pg45t',
  },
  malalaBooks: {
    text: 'Let us pick up our books and our pens. They are our most powerful weapons.',
    author: 'Malala Yousafzai',
    source: 'Address to the United Nations Youth Assembly, 12 July 2013',
    sourceUrl: 'https://www.un.org/webcast/pdfs/unia1397.pdf',
  },
  mandela: {
    text: 'Education is the most powerful weapon we can use to change the world and Mindset Network is a powerful part of that world changing arsenal.',
    author: 'Nelson Mandela',
    source: '“Lighting your way to a better future”, speech at the launch of Mindset Network, Johannesburg, 16 July 2003',
    sourceUrl: 'https://archive.nelsonmandela.org/index.php/za-com-mr-s-909',
  },
  seneca: {
    text: 'As long as you live, keep learning how to live.',
    author: 'Seneca (quoting a proverb)',
    source: 'Moral Letters to Lucilius, Letter 76, §3, trans. Richard M. Gummere, 1917',
    sourceUrl: 'https://senecaletters.com/en/letters/76',
  },
  locke: {
    text: 'Reading furnishes the mind only with materials of knowledge; it is thinking that makes what we read ours.',
    author: 'John Locke',
    source: 'Of the Conduct of the Understanding, §20',
    sourceUrl: 'https://www.ourcivilisation.com/smartboard/shop/lockej/reading.htm',
  },
  shakespeare: {
    text: 'Knowledge the wing wherewith we fly to heaven.',
    author: 'William Shakespeare',
    source: 'Henry VI, Part 2, Act 4, Scene 7',
    sourceUrl: 'https://www.folger.edu/explore/shakespeares-works/henry-vi-part-2/read/',
  },
  douglassStruggle: {
    text: 'If there is no struggle, there is no progress.',
    author: 'Frederick Douglass',
    source: '“West India Emancipation”, speech in Canandaigua, New York, 3 August 1857',
    sourceUrl: 'https://www.nps.gov/common/uploads/teachers/lessonplans/Abolition%20and%20Anti%20Slavery%20Texts%20in%20Hopedale%20-%20Primary%20Sources.pdf',
  },
  jefferson: {
    text: 'I cannot live without books.',
    author: 'Thomas Jefferson',
    source: 'Letter to John Adams, 10 June 1815',
    sourceUrl: 'https://www.loc.gov/collections/thomas-jefferson-papers/articles-and-essays/selected-quotations-from-the-thomas-jefferson-papers/',
  },
  confuciusReflection: {
    text: 'Learning without thought is labour lost; thought without learning is perilous.',
    author: 'Confucius (as recorded in the Analects)',
    source: 'Analects, Book 2, Chapter 15, trans. James Legge',
    sourceUrl: 'https://ctext.org/analects/wei-zheng/ens',
  },
  confuciusPractice: {
    text: 'Is it not pleasant to learn with a constant perseverance and application?',
    author: 'Confucius (as recorded in the Analects)',
    source: 'Analects, Book 1, Chapter 1, trans. James Legge',
    sourceUrl: 'https://ctext.org/analects/xue-er/ens',
  },
  dewey: {
    text: 'Education, therefore, is a process of living and not a preparation for future living.',
    author: 'John Dewey',
    source: '“My Pedagogic Creed”, School Journal, Vol. 54, 1897',
    sourceUrl: 'https://en.wikisource.org/wiki/My_Pedagogic_Creed',
  },
  huxley: {
    text: 'Perhaps the most valuable result of all education is the ability to make yourself do the thing you have to do when it ought to be done, whether you like it or not.',
    author: 'Thomas H. Huxley',
    source: '“A Liberal Education; and Where to Find It”, 1868',
    sourceUrl: 'https://www.gutenberg.org/files/7150/old/8sced10h.htm',
  },
  king: {
    text: 'Intelligence plus character—that is the goal of true education.',
    author: 'Martin Luther King Jr.',
    source: '“The Purpose of Education”, The Maroon Tiger, 1947',
    sourceUrl: 'https://kinginstitute.stanford.edu/king-papers/documents/purpose-education',
  },
  kennedy: {
    text: 'Leadership and learning are indispensable to each other.',
    author: 'John F. Kennedy',
    source: 'Prepared remarks for the Dallas Trade Mart, 22 November 1963 (undelivered)',
    sourceUrl: 'https://www.jfklibrary.org/archives/other-resources/john-f-kennedy-speeches/dallas-tx-trade-mart-undelivered-19631122',
  },
};
